import Marquee from "react-fast-marquee";

export default function MarqueeBand() {
    const words = ["Fitness", "Gravidanza", "Post Parto"];
    return (
        <section aria-hidden className="bg-powder py-6 md:py-10 border-y border-ink/10 overflow-hidden">
            <Marquee speed={70} gradient={false} pauseOnHover={false}>
                {words.concat(words).map((w, i) => (
                    <span
                        key={i}
                        className="serif-outline text-6xl md:text-8xl lg:text-9xl font-bold mx-6 md:mx-10 select-none"
                    >
                        {w} <span className="text-fuchsia" style={{ WebkitTextStroke: 0 }}>✦</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
